import { useQuery } from "@tanstack/react-query";
import { getProduct } from "../../core/product.core";
import CloseIcon from "../../icons/iconClose.comp";
import LocalePs from "../locale/localePs.core";
import Image from "next/image";

export default function ProductSearchItem({
  productId,
  removeProduct,
}: {
  productId: string;
  removeProduct: (productId: string) => void;
}) {
  const {
    data: product,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["singleProduct", productId],
    queryFn: (context) => getProduct(context.queryKey[1]),
    enabled: !!productId,
  });

  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>{error.message}</p>;
  if (!product) return null;

  return (
    <div className="related-product-item basis-1/4 relative">
      <button
        className="delete-btn flex items-center justify-center w-4 h-4 ml-2 text-xs font-semibold text-blue-800 bg-red-400 rounded-full hover:bg-red-400 hover:text-white right-0 absolute"
        onClick={() => removeProduct(product.id)}
      >
        <CloseIcon />
      </button>
      {product.featureMedia ? (
        <Image unoptimized src={product.featureMedia.thumbnailUrl} width={100} height={100} alt={product.featureMedia.filename} />
      ) : null}
      <LocalePs value={product.name} />
    </div>
  );
}
